/**
 * Ever since this application applies code splitting, all containers are
 * now being wrapped inside "LoadableComponent". Thus, server side preload method
 * that specified on the component is then hidden shallowly. We have to actually preload
 * the component before we can invoke these preloading methods.
 */
import { matchRoutes } from 'react-router-config';

function getComponents(matched) {
  return matched
    .map(v => v.route.component)
    .reduce(async (acc, component) => {
      if (component.preload) {
        const asyncComp = await component.preload();
        const result = [...(await acc), component, ...[].concat(asyncComp)];

        return result;
      }

      return [...(await acc), component];
    }, []);
}

function getParams(matchedComponents) {
  return matchedComponents.reduce((result, component) => {
    if (component.match && component.match.params) {
      return {
        ...result,
        ...component.match.params,
      };
    }

    return result;
  }, {});
}

const asyncMatchRoutes = async (routes, pathname) => {
  // Check if the param has query param
  // Match the routes without query params
  let path = pathname;
  if (pathname.indexOf('?') > -1) {
    [path] = pathname.split('?');
  }
  const matchedComponents = matchRoutes(routes, path);
  const components = await getComponents(matchedComponents);
  const params = getParams(matchedComponents);

  return {
    components,
    match: matchedComponents,
    params,
  };
};

export default asyncMatchRoutes;



// WEBPACK FOOTER //
// ./app/utils/asyncMatchRoutes.js